import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import remove from "@beeldit/core/services/remove";
import { GenerateSessionsActionContext } from "./GenerateSessionsActionContext";
import store from "@beeldit/core/services/store";

function useGenerateSessions(modelConfig: any) {
  const { elementId, setShowModal } = useContext(GenerateSessionsActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store(modelConfig.endpoint + '/generate-sessions', {id: elementId})
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGenerateSessions;
